import * as Yup from 'yup';

import { FormValues } from './types';

export const initialValues: FormValues = {
  deviceId: '',
};

export const validationSchema = Yup.object().shape({
  deviceId: Yup.string().required(),
});
